import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

import styles from "../../styles/style.module.scss";

const AddBulkEmail = ({
  show,
  setShow,
  handleClose,
  emailList,
  setEmailList,
  setTrainingData,
  trainingData,
}) => {
  const [localEmailList, setLocalEmailList] = useState("");

  const handleSubmit = () => {
    const latestEmailArray = localEmailList.split(",")?.map((email) => {
      return { email:email.trim(), id: null };
    });

    setEmailList([...latestEmailArray]);

    setTrainingData({
      ...trainingData,
      emails: [...latestEmailArray],
    });

    setShow(false);
  };

  return (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      backdropClassName={styles.modalBackdrop}
      contentClassName={styles.modalContent}
      dialogClassName={styles.modalDialog}
    >
      <Modal.Body>
        <div className={styles.modalHeading}>Assign Candidates</div>
        <textarea
          className={styles.assignEmailBox}
          placeholder="Enter the email address of assign candidates"
          onChange={(e) => {
            setLocalEmailList(e.target.value);
          }}
          value={localEmailList}
        />
        <Button
          variant="primary"
          className={styles.cancelButton}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className={styles.assignButton}
          onClick={handleSubmit}
        >
          Assign
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default AddBulkEmail;
